var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColour2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435.12 490.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #889bce;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "323.77 110.93 322.07 121.02 322.07 305.93 323.89 299.6 323.77 110.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "110.48 212.91 48.92 212.84 48.92 271.56 110.45 271.67 110.48 212.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.39 419.41 139.08 428.39 139.42 239.09 122.84 239.09 81.39 419.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.02 241.9 202.33 242.32 202.29 299.54 261.02 299.54 261.02 241.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 353.12,
    cy: 60.15,
    r: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 231.7,
    cy: 242.28,
    r: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 110.27,
    cy: 242.28,
    r: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.56,
    cy: 242.28,
    r: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 231.7,
    cy: 302.99,
    r: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 294.48,
    cy: 363.7,
    r: 29.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 232.87,
    cy: 363.7,
    rx: 30.55,
    ry: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 231.7,
    cy: 424.42,
    r: 29.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 110.27,
    cy: 424.42,
    r: 29.38,
    transform: "translate(-326.32 465.28) rotate(-80.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.29,361.72v.35c0,17.46-14.15,31.17-31.61,31.17s-31.36-14.15-31.49-31.5l-10.83-.02v66.33l95.69,24.87,10.02-91.2h-31.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.07,299.54c0,.18,0,.99,0,1.17,0,16.83-13.59,30.37-30.48,30.37s-30.52-13.55-30.52-30.38c0-.36-.07-.81-.05-1.16h-58.73s0,62.53,0,62.53h121.6v-62.53h-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.37,89.46v.02s.15-36.92.15-36.92l-27.75,8.4-1.71,60.07,1.7-2.37c.17-15.33,12.55-28.11,27.61-29.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColour2);
export default __webpack_public_path__ + "static/media/logo-colour-2.b6e6e297f377886badd20000b074b80a.svg";
export { ForwardRef as ReactComponent };